import types from '../types'
import 'firebase/compat/database'

export const getEditPrompts = (database) => async (dispatch) => {
  const dbRef = database.ref(`prompts`)

  await dbRef.on(
      'value',
      (snapshot) => {
        const val = snapshot.val()
        const editPrompts = val
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            editPrompts,
          },
        })
      },
      (errorObject) => console.log(errorObject),
  )
}
